import React from 'react';

const HorizontalRule = () => (
  <hr className="bg-cornflower border-0 h-1 mx-auto my-6 md:my-12 rounded w-48" />
);

export default HorizontalRule;
